import putPostRequestInterface from "./putPostRequestInterface";
import { AxiosInstance } from "./AxiosRequest";
import getRequestInterface from "./getRequestInterface";
import deleteRequestInterface from "./deleteRequestInterface";

const putPostRequest = async ({
  url,
  success,
  failure,
  body,
  method,
}: putPostRequestInterface) => {
  try {
    const data = await AxiosInstance.postPostRequest(url, body, method);
    return success(data);
  } catch (error) {
    return failure(error);
  }
};
const getAPIRequest = async ({
  url,
  success,
  failure,
}: getRequestInterface) => {
  try {
    const data = await AxiosInstance.getRequest(url);
    success(data);
  } catch (error) {
    failure(error);
  }
};
const deleteAPI = async ({
  url,
  success,
  failure,
  body,
}: deleteRequestInterface) => {
  try {
    const data = await AxiosInstance.deleteRequest(url, body);
    success(data);
  } catch (error) {
    failure(error);
  }
};
export { putPostRequest, getAPIRequest, deleteAPI };
